<template>
  <div class="sbs-rows">
    <div class="sbs-shared-note">
      Ko'rsatkichlar daraxti <b>barcha yillar uchun umumiy</b> — bu yerdagi o'zgarish hamma yil
      jadvaliga ta'sir qiladi. Ko'rsatkich {{ year ? year + "-yil" : "yil" }} jadvalida faqat unga
      chorak qiymati kiritilganda "to'ldirilgan" hisoblanadi; kerak bo'lmagan qatorlarni
      <b>Jadval</b> tabidagi "Faqat to'ldirilganlar" belgisi yashiradi.
    </div>

    <div class="sbs-toolbar">
      <el-input
          v-model="search"
          placeholder="Qidirish..."
          clearable
          class="sbs-search"
          @input="onSearchInput"
      >
        <template #prefix>🔎</template>
      </el-input>
      <el-button type="primary" @click="openCreate(null)">
        <span class="sbs-btn-plus">+</span> Ko'rsatkich qo'shish
      </el-button>
    </div>

    <el-skeleton v-if="loading" :rows="6" animated/>
    <MfEmpty
        v-else-if="!rows.length"
        title="Ko'rsatkichlar topilmadi"
        description="Yangi ko'rsatkich yaratish uchun yuqoridagi tugmani bosing"
    />
    <div v-else class="sbs-tree-wrap">
      <el-tree
          :data="rows"
          node-key="id"
          :props="{label: nodeLabel, children: 'children'}"
          default-expand-all
          :expand-on-click-node="false"
      >
        <template #default="{data}">
          <div class="sbs-tree-node" :class="{'is-inactive': data.is_active === false}">
            <span class="sbs-tree-number">{{ layerNumbers.get(data.id) }}</span>
            <span class="sbs-tree-title" :class="{'is-bold': data.is_bold}">
              {{ displayLangText(data.title) || "..." }}
              <sup v-if="displayLangText(data.note)" class="sbs-tree-note">{{ displayLangText(data.note) }}</sup>
            </span>
            <el-tag v-if="data.is_active === false" size="small" type="info" effect="plain">Nofaol</el-tag>
            <span class="sbs-tree-actions">
              <el-button type="success" plain title="Ostiga ko'rsatkich qo'shish" @click.stop="openCreate(data)">
                <span class="sbs-plus-ico">+</span>
              </el-button>
              <el-button type="primary" title="Tahrirlash" @click.stop="openEdit(data)">
                <img height="16" src="@/assets/images/icons/edit.svg" alt="Tahrirlash"/>
              </el-button>
              <el-button
                  type="danger"
                  title="O'chirish"
                  :loading="deletingId === data.id"
                  @click.stop="onDelete(data)"
              >
                <img height="16" src="@/assets/images/icons/delete.svg" alt="O'chirish"/>
              </el-button>
            </span>
          </div>
        </template>
      </el-tree>
    </div>

    <SubsidiesRowDialog
        v-model="dialogVisible"
        :row="editingRow"
        :parent-id="createParentId"
        :rows-tree="rows"
        @saved="fetchRows"
    />
  </div>
</template>

<script>
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";
import MfEmpty from "@/components/core/MfEmpty.vue";
import SubsidiesRowDialog from "./SubsidiesRowDialog.vue";
import {API_BASE, buildLayerNumbers, displayLangText, sortTreeByOrder} from "./subsidiesTypes";

export default {
  name: "SubsidiesRows",
  components: {MfEmpty, SubsidiesRowDialog},
  props: {
    year: {type: Number, default: null},
  },
  data() {
    return {
      rows: [],
      loading: false,
      search: "",
      searchTimer: null,
      dialogVisible: false,
      editingRow: null,
      createParentId: null,
      deletingId: null,
    };
  },
  computed: {
    // T/R har bir shoxda `order` bo'yicha qaytadan 1 dan sanaladi.
    layerNumbers() {
      return buildLayerNumbers(this.rows);
    },
  },
  methods: {
    displayLangText,
    nodeLabel(data) {
      return displayLangText(data.title) || "...";
    },
    handleApiError(error, fallbackTitle) {
      ElNotification({
        title: fallbackTitle,
        message: error?.response?.data?.message || "Iltimos, qayta urinib ko'ring.",
        type: "error",
      });
    },
    fetchRows() {
      this.loading = true;
      this.$http
          .get(`${API_BASE}/rows`, {params: {include_inactive: true, search: this.search || undefined}})
          .then(({data}) => {
            this.rows = sortTreeByOrder(Array.isArray(data) ? data : []);
          })
          .catch((error) => this.handleApiError(error, "Ko'rsatkichlarni yuklashda xatolik"))
          .finally(() => {
            this.loading = false;
          });
    },
    onSearchInput() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.fetchRows(), 350);
    },
    openCreate(parentRow) {
      this.editingRow = null;
      this.createParentId = parentRow?.id ?? null;
      this.dialogVisible = true;
    },
    openEdit(row) {
      this.editingRow = row;
      this.createParentId = null;
      this.dialogVisible = true;
    },
    onDelete(row) {
      const hasChildren = row.children && row.children.length > 0;
      const message = hasChildren
          ? "Bu ko'rsatkichning bolalari bor — avval ularni o'chiring yoki ko'chiring."
          : "Ko'rsatkichni o'chirasizmi?";
      if (hasChildren) {
        ElMessageBox.alert(message, "O'chirib bo'lmaydi", {confirmButtonText: "Tushunarli"});
        return;
      }
      ElMessageBox.confirm(message, "Ko'rsatkichni o'chirish", {
        confirmButtonText: "Ha, o'chirish",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
          .then(() => {
            this.deletingId = row.id;
            this.$http
                .delete(`${API_BASE}/rows/${row.id}`)
                .then(() => {
                  ElMessage({type: "success", message: "Ko'rsatkich o'chirildi"});
                  this.fetchRows();
                })
                .catch((error) => this.handleApiError(error, "O'chirishda xatolik"))
                .finally(() => {
                  this.deletingId = null;
                });
          })
          .catch(() => {
          });
    },
  },
  mounted() {
    this.fetchRows();
  },
};
</script>

<style scoped lang="scss">
$brand: #007791;
$border: #ebeef5;
$muted: #8a94a6;

.sbs-shared-note {
  margin-bottom: 14px;
  padding: 9px 14px;
  border-radius: 10px;
  background: rgba(0, 119, 145, 0.06);
  font-size: 12.5px;
  line-height: 1.55;
  color: #005c72;
}

.sbs-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.sbs-search {
  width: 280px;
}

.sbs-btn-plus {
  font-size: 16px;
  margin-right: 2px;
}

.sbs-tree-wrap {
  border: 1px solid $border;
  border-radius: 12px;
  padding: 10px 14px;
  box-shadow: 0 4px 14px rgba(15, 30, 80, 0.04);

  :deep(.el-tree-node__content) {
    height: 44px;
  }
}

.sbs-tree-node {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding-right: 8px;

  &.is-inactive {
    opacity: 0.55;
  }
}

.sbs-tree-number {
  min-width: 44px;
  font-size: 11.5px;
  color: $muted;
  font-family: "SFMono-Regular", Consolas, monospace;
}

.sbs-tree-title {
  flex: 1;
  min-width: 0;
  font-size: 13.5px;
  color: #303133;

  &.is-bold {
    font-weight: 700;
  }
}

.sbs-tree-note {
  color: $brand;
  margin-left: 2px;
}

.sbs-tree-actions {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  gap: 6px;
}

.sbs-plus-ico {
  font-size: 18px;
  line-height: 1;
}
</style>
